export const BACKEND_SERVER_URL = process.env.REACT_APP_BACKEND_URL;
export const CRYPTO_JS_SECRET_KEY = process.env.REACT_APP_CRYPTO_JS_SECRET_KEY;
